import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
//import { CustomLayoutModule } from './modules/custom-layout/custom-layout.module';
import { AuthService } from './services/auth.service';
import { NotificationService } from './services/notification.service';
import { AuthGuard } from 'src/core/guards/auth.guard';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './services/configuration.service';
import { UserService } from './services/user.service';
import { Error404Module } from './modules/errors/error-404/error-404.module';
import { Error500Module } from './modules/errors/error-500/error-500.module';
import { ForgotPasswordModule } from './modules/auth/forgot-password/forgot-password.module';
import { RegisterModule } from './modules/auth/register/register.module';
import { ResetPasswordModule } from './modules/auth/reset-password/reset-password.module';
//import { VexModule } from 'src/@vex/vex.module';
import { MatMaterialModule } from './modules/mat-material/mat-material.module';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VexPageLayoutComponent } from 'src/@vex/components/vex-page-layout/vex-page-layout.component';
import { VexPageLayoutContentDirective } from 'src/@vex/components/vex-page-layout/vex-page-layout-content.directive';
import { VexSecondaryToolbarComponent } from 'src/@vex/components/vex-secondary-toolbar/vex-secondary-toolbar.component';
import { VexPageLayoutHeaderDirective } from 'src/@vex/components/vex-page-layout/vex-page-layout-header.directive';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,MatMaterialModule,RouterModule,ReactiveFormsModule,FormsModule,VexPageLayoutComponent,VexPageLayoutContentDirective,VexSecondaryToolbarComponent,VexPageLayoutHeaderDirective
  ],
  exports:[TranslateModule,
    Error404Module,Error500Module,ForgotPasswordModule,RegisterModule,ResetPasswordModule,
    MatMaterialModule,CommonModule,ReactiveFormsModule,FormsModule,VexPageLayoutComponent,VexPageLayoutContentDirective,VexSecondaryToolbarComponent,VexPageLayoutHeaderDirective],
  providers:[AuthService,ConfigurationService,NotificationService,UserService]
})
export class SharedModule { }
